import { Component } from 'react'
import { node, bool } from 'prop-types'

class BodyClass extends Component {
  componentDidMount() {
    // IE11 classList.toggle is not working as expected.
    if (!this.isIE11()) {
      document.body.classList.toggle('no-scroll', this.props.noScroll)
    }
  }

  componentWillReceiveProps(nextProps) {
    // IE11 classList.toggle is not working as expected.
    if (!this.isIE11()) {
      document.body.classList.toggle('no-scroll', nextProps.noScroll)
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll')
  }

  render() {
    return this.props.children
  }

  isIE11() {
    return !!window.MSInputMethodContext && !!document.documentMode
  }
}

BodyClass.propTypes = {
  noScroll: bool,
  children: node.isRequired,
}

BodyClass.defaultProps = {
  noScroll: false,
}

export default BodyClass



// WEBPACK FOOTER //
// ./components/body-class/index.js